export const SUPPORTS_ARRAY_PROTOTYPE_REDUCE = "reduce" in Array.prototype;
